export default __webpack_public_path__ + "static/media/cloud-application-development.0f74b86c.png";